<template>
  <div :class="{'loading-overlay': true, 'loading-overlay-hide': !show}" >
    <div class="d-flex h-100 w-100 justify-content-center">
      <div class="align-self-center">
        <icon name="spinner" pulse/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'loading-overlay',
    props: {
      show: {
        default: false
      }
    }
  }
</script>

<style lang="scss">
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #343a40;
    opacity: 0.2;
    color: #f8f9fa;

    .fa-icon {
      width: 4rem;
      height: 4rem;
    }
  }

  .loading-overlay-hide {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadingOverlay.vue